import {Pipe, PipeTransform} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {NoticeEntry} from "../../pages/client/alarms/notices/notice.entry";

@Pipe({name: 'parkingNotice'})
export class ParkingNoticePipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  public transform(value: NoticeEntry): string {
    let result = '';
    if (value != null) {
      let additionalInfos = value.additionalInfo.split(',');
      result = additionalInfos.map(additionalInfo => {
        let info = additionalInfo.split(" / ");
        return this.translate.instant('messages.notices.restTypes.' + info[0]) +
          ' x ' + info[1];
      }).join(' | ');
      result = this.translate.instant('messages.notices.PARKING_NOT_PLANNED') + ': ' + result;
    }
    return result;
  }
}
